import React from 'react';
import Link from 'next/link';
import config from '@root/config';
import _get from 'lodash/get';
import qs from 'querystring';

class Doctor extends React.PureComponent {
    state = {
        loading: false
    }
    render() {
        const { doctor, query,facility } = this.props;
        const { loading } = this.state;
        const q = {
            ...query, 
            slug: doctor.slug,
            facility: this.props.facility,
            fcname: this.props.fcname, 
            header: this.props.headerHeight
        }
        const prefix = config.folder ? config.folder : '/';
        let doctorPhoto = `${config.folder}static/assets/images/nodoctorimage.png`;
        if (doctor.profilePicture) {
            doctorPhoto = doctor.profilePicture
        }
        let rs = null; 
        if (doctor && doctor.locations) {
            rs = doctor.locations.find(e => e.id === +facility);
        }

        if (!rs) {
            return null;
        }
        
        return (
            <div className="profile">
                <div className="profile-info">
                    <div className="profile__img">
                    <div className="thumbnail">
                        <img src={doctorPhoto} className="thumbnail__img"/>
                    </div>
                    </div>
                    <div className="profile__text">
                    <p className="text-bold mb-1">{doctor.title}</p>
                    {doctor.specialityIndonesian && (
                        <small>{doctor.specialityIndonesian[0]}</small>
                    )}
                    <p className="profile__location">{rs.name || _get(doctor, 'locations[0].name', '')}</p>
                    <div className="profile-btn">
                        <Link href={
                            {
                                pathname: `${prefix}book`, 
                                query: q
                            }
                        } as={`${prefix}book/${doctor.slug}?${qs.stringify(q)}`}>
                            <a disabled={loading} className={`btn btn-green ${loading ? 'loading' : ''}`}
                            onClick={() => {
                                this.setState({
                                    loading: true
                                });
                            }}>{loading ? 'loading...' : 'Ambil Antrian'}</a>
                        </Link>
                    </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Doctor;